import type { Header } from '@/types/table/table';
import type { ActivityLogViewId } from '../types/types';

export const ACTIVITY_LOGS_ROUTE_PATH = '/private/activity-logs';
export const ACTIVITY_LOGS_TABLE_NAME = 'brokerin_folios_v2';

/**
 * Inventario de `analisis/02-folios.md §1.2`, en el orden del rediseño.
 * `hideAt` es consumido por DsDataTable; no se usan reglas CSS por pantalla.
 * DsDataTable aún persiste anchos explícitos y no admite una última columna
 * `minmax(90px, 1fr)` dinámica; queda pendiente de una extensión de layout.
 */
export const ACTIVITY_LOG_HEADERS: Header[] = [
    { key: 'folio', title: 'Folio', width: 116, minWidth: '90px', maxWidth: '260px', sortable: true, show: true, lockShow: true },
    { key: 'asegurado', title: 'Asegurado · Movimiento', width: 232, minWidth: '160px', maxWidth: '420px', sortable: true, show: true, lockShow: true },
    { key: 'aseguradora', title: 'Subramo · Aseguradora', width: 218, minWidth: '160px', maxWidth: '420px', sortable: true, show: true, lockShow: true, hideAt: 'lg' },
    { key: 'estatus', title: 'Estatus', width: 182, minWidth: '130px', maxWidth: '320px', sortable: true, show: true, lockShow: true },
    { key: 'responsable', title: 'Responsable', width: 130, minWidth: '100px', maxWidth: '240px', sortable: true, show: true, lockShow: true, hideAt: 'lg' },
    { key: 'sla', title: 'SLA', width: 106, minWidth: '90px', maxWidth: '180px', sortable: true, show: true, lockShow: true },
    { key: 'poliza', title: 'Póliza', width: 160, minWidth: '110px', maxWidth: '320px', sortable: true, show: true, lockShow: true, hideAt: 'md' },
    { key: 'auxiliar', title: 'Auxiliar', width: 140, minWidth: '100px', maxWidth: '260px', sortable: true, show: true, lockShow: true, hideAt: 'lg' },
    { key: 'businessDaysWithNoActivity', title: 'Días hábiles sin actividad', width: 232, minWidth: '160px', maxWidth: '420px', sortable: false, show: true, lockShow: true },
];

/**
 * Auxiliar es una columna protegida cuando el agente tiene equipo; sin
 * auxiliares, el filtro de equipo no debe activar la columna por accidente.
 */
export function applyActivityLogAuxiliaryVisibility(headers: Header[], hasAuxiliaries: boolean): Header[] {
    return headers.map((header) => {
        if (header.key !== 'auxiliar') return { ...header };

        return {
            ...header,
            show: hasAuxiliaries && header.show !== false,
            lockShow: hasAuxiliaries ? header.lockShow : false
        };
    });
}


/**
 * Columnas del modal de exportación. Los fields corresponden al contrato real de export_folio.
 * Flujo, Póliza y Días usan los campos que export_folio calcula igual que la lista (QA 7853 TC-28).
 */
export const ACTIVITY_LOG_EXPORT_COLUMNS = [
    { field: 'folio', label: 'Folio' },
    { field: 'insured_name', label: 'Asegurado' },
    { field: 'kind', label: 'Movimiento' },
    { field: 'flow_name', label: 'Flujo' },
    { field: 'subramo', label: 'Subramo' },
    { field: 'friendly_name', label: 'Aseguradora' },
    { field: 'status', label: 'Estatus' },
    { field: 'sub_status_title', label: 'Subestatus' },
    { field: 'create_date', label: 'Fecha de creación' },
    { field: 'custody', label: 'Responsable' },
    { field: 'auxiliar', label: 'Auxiliar' },
    { field: 'flag', label: 'SLA' },
    { field: 'pylc_days', label: 'Días PyLC' },
    { field: 'agent_days', label: 'Días agente' },
    { field: 'business_days_with_no_activity', label: 'Días hábiles sin actividad' },
    { field: 'policy_label', label: 'Póliza' }
] as const;
export const ACTIVITY_LOG_VIEWS: Array<{
    id: ActivityLogViewId;
    label: string;
    tone: 'toca' | 'pylc' | 'entregado' | 'fuera';
    isAll?: boolean;
    favorite?: boolean;
}> = [
    { id: 'favoritos', label: 'Favoritos', tone: 'entregado', favorite: true },
    { id: 'todos', label: 'Todos mis Folios', tone: 'pylc', isAll: true },
    { id: 'incompleta', label: 'Información incompleta', tone: 'toca' },
    { id: 'entregados', label: 'Entregados', tone: 'entregado' },
    { id: 'cotizaciones', label: 'Cotizaciones', tone: 'fuera' }
];
